import { SubmissionError } from 'redux-form';
import { supo } from '../api';
import ActionTypes from '../constants/ActionTypes';

export const getBunningsStores = () => async dispatch => {
  const { data } = await supo.get('/partner/3/store_locations');

  if (data.errors) {
    throw new SubmissionError(data.errors);
  }
  if (data) {
    dispatch({ type: ActionTypes.STORE_LOCATION_SUCCESS, payload: data });
  }
};
